import { QueueStatus } from '@config/constants/enum';
import { Box } from '@mantine/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import classes from './Tag.module.css';

export const Tag = ({
	type,
	label,
}: {
	type: string;
	label: string;
}) => {
	const { t } = useTranslation();
	const getTypeTag = (type: string) => {
		switch (type) {
			case QueueStatus.SUCCESS:
				return classes.success;
			case QueueStatus.PENDING:
				return classes.warning;
			case QueueStatus.ERROR:
				return classes.error;

			default:
				break;
		}
	};

	const getLabelByType = (type: string) => {
		switch (type) {
			case QueueStatus.SUCCESS:
				return t('global.complete');
			case QueueStatus.PENDING:
				return t('global.pending');
			case QueueStatus.ERROR:
				return t('global.error');
			default:
				return t('global.pending');
		}
	};
	return (
		<Box
			className={clsx(
				classes.container,
				getTypeTag(type)
			)}
		>
			{getLabelByType(type)}
		</Box>
	);
};
